import { useContext } from 'react'

import { FullUrlContext } from '../FullUrlContext'

export const useFullUrl = function useFullUrl() {
  return useContext(FullUrlContext)
}
